// extracted by mini-css-extract-plugin
export default {"root":"root--pfAQr","wide":"wide--H8_1y","maxOccupancyMessage":"maxOccupancyMessage--Ic46f","message":"message--kfgk_","overMax":"overMax--R_xNQ"};